export class Cargo {
  packageNo: string;
  packageId: string;
}
